export function extractAddressComponents(
  components: google.maps.GeocoderAddressComponent[] | undefined,
) {
  const get = (type: string) =>
    components?.find((comp) => comp.types.includes(type))?.long_name || "";

  return {
    street: `${get("street_number")} ${get("route")}`.trim(),
    city: get("locality") || get("administrative_area_level_2"), // Fallback to district if city is missing
    state: get("administrative_area_level_1"),
    postalCode: get("postal_code"),
    country: get("country"),
  };
}
